import { money, fmtKST } from "@/lib/api";

const btn = "rounded-full border px-2.5 py-0.5 text-[11px] font-semibold transition-colors";

const Status = ({ c }) => {
  if (c.forfeited) return <span className="text-red-300">Dropped · unpaid</span>;
  if (c.fee_waived) return <span data-testid={`late-claim-waived-${c.id}`} className="text-emerald-300">Late fee waived{c.waived_fee > 0 ? ` (${money(c.waived_fee)})` : ""}</span>;
  if (c.overdue) return <span className="text-red-300">Late fee {money(c.late_fee)}</span>;
  if (c.restored_at) return <span className="text-sky-300">Restored · pay by {fmtKST(c.pay_by)}</span>;
  return <span className="text-zinc-400">Paid or settled</span>;
};

export const LateClaimRow = ({ c, onWaive, onRestore }) => (
  <li data-testid={`late-claim-${c.id}`} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
    <span className="text-zinc-200 min-w-0 break-words">{c.label}</span>
    <Status c={c} />
    <span className="ml-auto flex gap-1.5">
      {c.can_waive && (
        <button type="button" data-testid={`late-claim-waive-${c.id}`} onClick={() => onWaive(c)} className={`${btn} border-emerald-500/40 text-emerald-200 hover:bg-emerald-500/10`}>Waive fee</button>
      )}
      {c.forfeited && (c.can_restore
        ? <button type="button" data-testid={`late-claim-restore-${c.id}`} onClick={() => onRestore(c)} className={`${btn} border-sky-500/40 text-sky-200 hover:bg-sky-500/10`}>Restore claim</button>
        : <span data-testid={`late-claim-slot-taken-${c.id}`} className="text-[11px] text-zinc-500">Slot filled · can't restore</span>)}
    </span>
  </li>
);
